<template>
    <ais-instant-search :search-client="searchClient" :index-name="$root.index">
        <ais-configure :hits-per-page.camel="hitPerPage" />
        <!-- PLaceholder for user question -->

        <div class="mt-xxl mb-xl container">
            <div class="info-wrap pt-lg">
                <p class="h6 mb-md">What best describes what you're looking for?</p>

                <div class="info">
                    <button :class="{ 'is-active': view === 'map' }" @click="view = 'map'">
                        <svg class="icon "><use xlink:href="#geosearch-pin" /></svg>
                        <template v-if="$root.index == 'installers'">
                            Find accredited installers near me
                        </template>
                        <template v-else>
                            Find Approved Solar Retailers near me
                        </template>
                    </button>
                    <span>OR</span>
                    <button :class="{ 'is-active': view === 'list' }" @click="view = 'list'">
                        <svg class="icon "><use xlink:href="#geosearch-clipboard" /></svg>
                        <template v-if="$root.index == 'installers'">
                            Check if a specific installer is accredited
                        </template>
                        <template v-else>
                            Check if a specific retailer is approved
                        </template>
                    </button>
                </div>
            </div>
        </div>

        <!-- Header -->
        <div class="geosearch">
            <div class="container geosearch-header">
                <h3 class="h3 mb-sm">
                    <template v-if="$root.index == 'installers'">
                        Find Installers
                    </template>
                    <template v-else>
                        Find Retailers
                    </template>
                </h3>

                <div class="geosearch-tools">
                    <ais-search-box v-if="view === 'list'" v-slot="{ currentRefinement, refine }">
                        <svg class="icon ais-SearchBox-icon" @click="refine($refs.searchbox.value)">
                            <use xlink:href="#geosearch-search" />
                        </svg>
                        <input
                            ref="searchbox"
                            class="ais-SearchBox-input"
                            type="search"
                            :value="currentRefinement"
                            placeholder="Search by name"
                            @keyup.enter="refine($event.currentTarget.value)"
                        />
                    </ais-search-box>

                    <Places v-if="view === 'map'" class="ais-SearchBox" @change="newSearch" />

                    <div class="geosearch-switcher">
                        <button :class="{ 'is-active': view === 'map' }" @click="view = 'map'">
                            <svg class="icon "><use xlink:href="#geosearch-pin" /></svg>
                            <span>By location</span>
                        </button>
                        <button :class="{ 'is-active': view === 'list' }" @click="view = 'list'">
                            <svg class="icon "><use xlink:href="#geosearch-list" /></svg>
                            <span>By name</span>
                        </button>
                    </div>

                    <Filters
                        v-if="$root.index === 'installers'"
                        :attributes="['accreditations', 'systemTypes']"
                    />

                    <SortBy v-else-if="view === 'list'" />
                </div>
            </div>
        </div>

        <div>
            <ListView v-if="view === 'list'" ref="list" />
            <MapView v-if="view === 'map'" ref="map" />
        </div>
    </ais-instant-search>
</template>

<script>
import algoliasearch from 'algoliasearch/lite';
import ListView from './ListView.vue';
import MapView from './MapView.vue';
import Places from './Places.vue';
import Filters from './Filters.vue';
import SortBy from './SortBy.vue';

export default {
    components: {
        ListView,
        MapView,
        Places,
        Filters,
        SortBy
    },

    data() {
        return {
            view: 'map',
            searchClient: algoliasearch(window.algoliaId, window.algoliaSearchKey)
            // searchClient: algoliasearch('YHXHHIW5CJ', '482fe0c5f0be1cf058eb9f8bcd94520d')
        };
    },

    computed: {
        hitPerPage() {
            return this.view === 'map' ? 1500 : 6;
        }
    },

    methods: {
        newSearch(latlng) {
            this.$refs.map.activeMarker = null;
            this.$refs.map.setBounds(latlng);
        }

        // label(single = false, title = false) {
        //     let string = this.$root.index;
        //     if (single) string = string.slice(0, -1);

        //     if (title) string = string.charAt(0).toUpperCase() + string.substr(1).toLowerCase();
        //     return string;
        // }
    }
};
</script>

<style lang="scss" scoped>
/* Info */
.info-wrap {
    border-top: 1px solid #dddddd;
}

.info {
    @media screen and (min-width: 769px) {
        display: flex;
        align-items: center;
    }

    button {
        display: flex;
        align-items: center;
        width: 100%;
        border: 2px solid #e9e9e9;
        border-radius: 5px;
        padding: 1.5em 2em;
        font-weight: 500;
        flex: 1;
        font-size: 16px;
        outline: none;

        @media screen and (min-width: 769px) {
            padding-top: 2.5em;
            padding-bottom: 2.5em;
        }

        svg {
            font-size: 28px;
            color: #ef6e0b;
            margin-right: 0.75em;
        }

        &.is-active {
            border-color: #ef6e0b;
        }
    }

    span {
        display: block;
        text-align: center;
        padding: 1.5em;
        font-size: 13px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 1px;

        @media screen and (min-width: 769px) {
            padding-top: 0;
            padding-bottom: 0;
        }
    }
}

.geosearch {
    border-top: 1px solid #dddddd;
    border-bottom: 1px solid #dddddd;
}

.geosearch-header {
    padding-top: 2em;
    padding-bottom: 3em;
}

.geosearch-tools {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    @media screen and (min-width: 769px) {
        flex-wrap: nowrap;
        flex-direction: row-reverse;
    }
}

.geosearch-switcher {
    display: flex;
    height: 49px;

    @media screen and (min-width: 769px) {
        order: 1;
    }

    button {
        display: flex;
        align-items: center;
        border: 1px solid #dddddd;
        font-weight: 500;
        padding: 0.5em 1em;
        outline: none;
        border-radius: 5px;
        white-space: nowrap;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
        font-size: 17px;

        &:last-child {
            margin-left: 1em;

            @media screen and (min-width: 1024px) {
                margin-left: 2em;
            }
        }

        &.is-active {
            border-color: #ef6e0b;
            box-shadow: none;
        }

        span {
            display: none;

            @media screen and (min-width: 1024px) {
                display: block;
                margin-left: 0.75em;
            }
        }

        .icon {
            font-size: 20px;
            color: #ef6e0b;
        }
    }
}

// .geosearch-switcher {
//     display: flex;
//     height: 49px;

//     @media screen and (min-width: 769px) {
//         margin-top: 0;
//         height: auto;
//         order: -1;
//     }

//     button {
//         display: flex;
//         align-items: center;
//         border: 1px solid #dddddd;
//         font-size: 13px;
//         font-weight: 500;
//         padding: 0.5em 2em;
//         outline: none;

//         &:first-child {
//             border-top-left-radius: 999px;
//             border-bottom-left-radius: 999px;
//         }

//         &:last-child {
//             border-top-right-radius: 999px;
//             border-bottom-right-radius: 999px;
//         }

//         &.is-active {
//             border-color: #ef6e0b;
//             background-color: #fff2e9;
//             color: #ef6e0b;
//         }

//         span {
//             display: none;

//             @media screen and (min-width: 1024px) {
//                 display: block;
//                 margin-left: 0.75em;
//             }
//         }
//     }

//     .icon {
//         font-size: 17px;
//     }
// }

::v-deep .ap-input {
    width: 350px;
    border-radius: 999px;
    padding: 0 2em 0 1.5em;
}

.ais-SearchBox {
    display: flex;
    align-items: center;
    width: 100%;
    margin-bottom: 1em;
    padding: 0.25em 0.5em;
    border-radius: 999px;
    border: 1px solid #dddddd;
    overflow: hidden;

    @media screen and (min-width: 769px) {
        width: 400px;
        margin-bottom: 0;
    }

    ::v-deep {
        .ais-SearchBox-input {
            flex: 1;
            border: 0;
            line-height: 38px;
            padding: 0;
            height: 38px;
            font: inherit;
            outline: none;
        }

        .ais-SearchBox-icon {
            margin: 0 0.75em;
            font-size: 20px;
            color: #ef6e0b;
            cursor: pointer;
        }
    }
}
</style>
